import { useEffect, useRef } from 'react';

const SCROLL_DELAY_MS = 100;

/**
 * Custom hook to auto-scroll to the top of a message when it completes
 * @param isLastMessage - Whether this is the last message in the thread
 * @param shouldShowTyping - Whether the typing indicator is showing
 * @param isRunning - Whether the thread is currently running
 * @returns A ref to attach to the message element
 */
export const useScrollToMessage = (
  isLastMessage: boolean,
  shouldShowTyping: boolean,
  isRunning: boolean,
) => {
  const messageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Only scroll when:
    // 1. It's the last message
    // 2. Typing just finished (not showing typing indicator)
    // 3. Thread is not running (message is complete)
    if (
      isLastMessage &&
      !shouldShowTyping &&
      !isRunning &&
      messageRef.current
    ) {
      // Small delay to ensure content is rendered
      setTimeout(() => {
        messageRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, SCROLL_DELAY_MS);
    }
  }, [isLastMessage, shouldShowTyping, isRunning]);

  return messageRef;
};
